<script lang="ts">
  import type { Snippet } from "svelte";
  import { dataField } from "../../lib/dataform/dataFormLib.svelte";

  let {
    name,
    class: className = "text-error",
    renderer
  } : {
    name : string;
    class? : string;
    renderer? : Snippet<[error: string]>
  } = $props()

  const field = $derived(dataField(name))
</script>
{#if field.error}
  {#if renderer}
    {@render renderer(field.error as string)}
  {:else}
    <p class={className}>{field.error}</p>
  {/if}
{/if}
